import { SET_CREATOR, CLEAR_CREATOR } from "./creatorAction";
const setCookie = (name, value, days) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(
    value,
  )}; expires=${expires}; path=/`;
};

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
};

let initialState = {
  creator: null,
  token: null,
};

const cookieValue = getCookie("paramCreator");
const tokenValue = getCookie("paramCreatorToken");

if (cookieValue) {
  try {
    const parsedCreator = JSON.parse(cookieValue);
    initialState.creator = parsedCreator || null;
  } catch (error) {
    // console.error("Failed to parse creator from cookie:", error);
  }
}

if (tokenValue) {
  initialState.token = tokenValue;
}

const creatorReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CREATOR:
      const { creator, token } = action.payload;
      setCookie("paramCreator", JSON.stringify(creator), 25);
      setCookie("paramCreatorToken", token, 25);
      return { ...state, creator, token };
    case CLEAR_CREATOR:
      setCookie("paramCreator", "", -1);
      setCookie("paramCreatorToken", "", -1);
      return { ...state, creator: null, token: null };

    default:
      return state;
  }
};

export default creatorReducer;
